package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_05_10_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have just woken up after a long rest, recovering from a grueling battle with Hezrou warriors. Our heroes bravely return to the depths, where they notice that sound is dampened inside the cavern.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes spot Vrocks — a breed of fiend they had previously fought back in Newgrowth 28. The Vrocks are surrounded by a cloud of spores and have a terrible screech. After defeating the Vrocks, the heroes continue deeper into the depth to the northeast.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes spot two Drow sisters speaking. But these “Drow” are not what they seem and in fact are Yochlol and are backed up by several Ropers. Our heroes are denied total victory when the final enemy Yochlol transforms into a misty cloud and floats up to the vents above.")
    }
}
